import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'dat.gui'
import { GLTFLoader, GLTFloader } from 'three/examples/jsm/loaders/GLTFLoader.js'

/**
 * Loaders
 */

const gltfLoader = new GLTFLoader()
const cubeTextureLoader = new THREE.CubeTextureLoader()





/**
 * Base
 */
// Debug
const gui = new dat.GUI()
const debugObject = {}
dat.GUI.toggleHide();

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Update All Materials
 */
const updateAllMaterials = () => 
{
    scene.traverse((child) => 
    {
        if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
        {
            // child.material.envMap = environmentMap
            child.material.envMapIntensity = debugObject.envMapIntensity
            child.material.needsUpdate = true
            child.castShadow = true
            child.receiveShadow = true

        }
        
    })
}

/**
 * Environment Map
 */
const environmentMap = cubeTextureLoader.load([
    '/textures/environmentMaps/1/px.jpg',
    '/textures/environmentMaps/1/nx.jpg',
    '/textures/environmentMaps/1/py.jpg',
    '/textures/environmentMaps/1/ny.jpg',
    '/textures/environmentMaps/1/pz.jpg',
    '/textures/environmentMaps/1/nz.jpg',
])
environmentMap.encoding = THREE.sRGBEncoding

scene.background = environmentMap
scene.environment = environmentMap

debugObject.envMapIntensity = 2.039
gui.add(debugObject, 'envMapIntensity').min(0).max(10).step(0.001).name('EnvMapIntensity').onChange(updateAllMaterials)

/**
 * Models
 */
var parent = new THREE.Group()
scene.add(parent)


gltfLoader.load(
    '/models/Mushroom/Mushroom_Psilocybe.glb',
    (mushroom) => 
    {  
        mushroom.scene.children[5].scale.set(50,50,50)
        mushroom.scene.children[5].position.set(0, -2, 0)

        


        gui.add(mushroom.scene.children[5].position, 'x').min(-5).max(5).step(0.001).name('MushroomX')
        gui.add(mushroom.scene.children[5].position, 'y').min(-5).max(5).step(0.001).name('MushroomY')
        gui.add(mushroom.scene.children[5].position, 'z').min(-5).max(5).step(0.001).name('MushroomZ')
        gui.add(mushroom.scene.children[5].rotation, 'y').min(- Math.PI).max(Math.PI).step(0.001).name('MushroomRotation')
        parent.add(mushroom.scene.children[5])
        updateAllMaterials()
    
    }
)

// gltfLoader.load(
//     '/models/FlightHelmet/glTF/FlightHelmet.gltf',
//     (helmet) => 
//     {
//         helmet.scene.scale.set(10,10,10)
//         helmet.scene.position.set(-5, -4, 0)
//         helmet.scene.rotation.y = Math.PI * 0.5
//         scene.add(helmet.scene) 

//         gui.add(helmet.scene.position, 'x').min(-5).max(5).step(0.001).name('HelmetX')
//         gui.add(helmet.scene.position, 'y').min(-5).max(5).step(0.001).name('HelmetY')
//         gui.add(helmet.scene.position, 'z').min(-5).max(5).step(0.001).name('HelmetZ')
//         gui.add(helmet.scene.rotation, 'y').min(- Math.PI).max(Math.PI).step(0.001).name('HelmetRotation')

//         updateAllMaterials()
//     }
// )

/**
 * Lights
 */
const directionalLight = new THREE.DirectionalLight('#ffffff', 3.666)
directionalLight.position.set(-3.178, 0.4, - 0.793)
directionalLight.castShadow = true
directionalLight.shadow.camera.far = 15
directionalLight.shadow.camera.top = 8
directionalLight.shadow.camera.bottom = -8
directionalLight.shadow.camera.left = 8
directionalLight.shadow.camera.right = -8
directionalLight.shadow.mapSize.set(2048, 2048)
directionalLight.shadow.normalBias = 0.03
scene.add(directionalLight)

// const directionalLightCameraHelper = new THREE.CameraHelper(directionalLight.shadow.camera)
// scene.add(directionalLightCameraHelper)


gui.add(directionalLight, 'intensity').min(0).max(10).step(0.001).name('LightIntensity')
gui.add(directionalLight.position, 'x').min(-5).max(5).step(0.001).name('lightX')
gui.add(directionalLight.position, 'y').min(-5).max(5).step(0.001).name('lightY')
gui.add(directionalLight.position, 'z').min(-5).max(5).step(0.001).name('lightZ')
/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(2, 1.45, - 6)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.physicallyCorrectLights = true
renderer.outputEncoding = THREE.sRGBEncoding
renderer.toneMapping = THREE.ACESFilmicToneMapping
renderer.toneMappingExposure = 1.941
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap

gui.add(renderer, 'toneMapping', {
    No: THREE.NoToneMapping,
    Linear: THREE.LinearToneMapping,
    Reinhard: THREE.ReinhardToneMapping,
    Cineon: THREE.CineonToneMapping,
    ACESFilmic: THREE.ACESFilmicToneMapping
})
.onFinishChange(() => 
{
    renderer.toneMapping = Number(renderer.toneMapping)
    updateAllMaterials()
})

gui.add(renderer, 'toneMappingExposure').min(0).max(5).step(0.001).name('ToneMapExposure')


/**
 * Animate
 */

const clock = new THREE.Clock()
const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const rotatespeed = elapsedTime * 0.05

    parent.rotation.y = - elapsedTime / 10

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()